module.exports = __webpack_public_path__ + "img/9788954614566.9387ff0e.jpg";